import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from '#/renderer/router';
import { isMobile } from 'react-device-detect';
import { map } from 'lodash-es';

// Helpers
import { cuotaFormat, currencyFormat, imgFormat } from '~/helpers/formatter';
import analytics from '~/helpers/analytics';
import useStores from '~/store/StoreHook';
//import blukai, removido

// Helpers
import helpers, { calculateTheMinPriceOffer, getProductsColors, getProductsSize, getProductsSizeScreen } from '~/helpers/product';

// TODO: export switch color to productjs
import FacetsUtils from '~/helpers/facets_utils';
import ESimIndicator from '~/components/ESimIndicator/ESimIndicator';

const ProductBoxTitle = ({ title }) => {
  const fullname = title.locales[process.env.NEXT_PUBLIC_LOCALE].name.replace(/<br>/, '\n').replace(/<br\/>/, '\n').replace(/\\n/, '\n').split('\n')
  .map((str, index) => <h2 key={`h3-${title.part_number}--${index}`}>{str}</h2>);
  if (isMobile) {
    return (
      <div className="product--box--title" style={{ marginTop: '1em' }} key={`div-title-mobile-${title.part_number}`}>
        {fullname}
      </div>
    );
  } else {
    return (
      <div className="product--box--title" key={`div-title-${title.part_number}`}>
        {fullname}
      </div>
    );
  }
};

const ProductBoxImg = ({ image }) => {
  let img = 'Producto sin imagen';
  if (image && image.images && image.images.length) {
    img = <img src={imgFormat('210x180', `${process.env.NEXT_PUBLIC_CDN_PATH}${image.images[0]}`)} alt="products" />;
  }
  return (
    <picture>
      {img}
    </picture>
  );
};

const ProductBoxPrice = ({ price, planName, defaultPlanName }) => {
  const name = planName || defaultPlanName;

  const { orderStore } = useStores();
  const [textoPospago, setTextoPospago] = useState();
  const [aceptaCuotas, setAceptaCuotas] = useState(false);
  const [formatoCuotas, setFormatoCuotas] = useState('');
  const [precio_minimo_incluido, setPrecio_minimo_incluido] = useState('');
  let min;

  useEffect(() => {
    async function init() {
      if (!orderStore.getCartConfig || !orderStore.getCartConfig.success) {
        await orderStore.getConfig();
      }
      if (orderStore.getCartConfig.success) {
        setTextoPospago(orderStore.getCartConfig.data.data.textoPospago);
        min = orderStore.getCartConfig.data.data.precioMinimoCuotas || 0;
        if (orderStore.getCartConfig.data.data.precio_minimo_incluido) {
          setPrecio_minimo_incluido(parseFloat(orderStore.getCartConfig.data.data.precio_minimo_incluido));
        }

        setAceptaCuotas(price.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price >= (min * 100));
        setFormatoCuotas(orderStore.getCartConfig.data.data.formatoCuotas || '');
      }
    }
    init();
  }, [price.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price]);

  let curencyOffer;
  let curencyList;
  // let isPlan;
  let isIncluded = false;
  // let precioo;
  let hasPromo = price.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price !== price.pricing[process.env.NEXT_PUBLIC_CURRENCY].list_price;
  const getPrice = price && price.pricing && price.pricing[process.env.NEXT_PUBLIC_CURRENCY];
  if (getPrice) {
    curencyOffer = currencyFormat(price.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price).split('.');
    curencyList = currencyFormat(price.pricing[process.env.NEXT_PUBLIC_CURRENCY].list_price).split('.');
  }
  let label = '';
  let labelContado = '';
  let labelCuota = '';
  let paymentLabel = '';
  let priceclass = 'product--box--price';
  const atributesMap = helpers.convertAttributes(price.attributes);
  const tipoProducto = atributesMap['attr-conf-tipoproducto'];
  const pagoRecurrente = atributesMap['attr-conf-pagorecurrente'];
  const precioMensual = atributesMap['attr-conf-precio-mensual'];
  const cuotas = atributesMap['attr-conf-pagocuotas'];
  const textoCuota = atributesMap['attr-texto-cuotas'];
  if (pagoRecurrente === 'SI') {
    paymentLabel = 'Al mes';
    hasPromo = false;
    // isPlan = true;
  } else {
    paymentLabel = hasPromo ? 'OFERTA' : atributesMap['attr-texto-precio'];
  }
  if (precioMensual && curencyOffer[0] === '0' && curencyOffer[1] === '00') {
    curencyOffer = currencyFormat(precioMensual, 1).split('.');
    // precioo = currencyFormat(precioMensual, 1).split('.');
  }
  if (tipoProducto === 'ADDONS') {
    label = 'Precio de la licencia';
  } else if (tipoProducto === 'PLAN') {
    label = 'Precio de tu plan';
  } else {
    label = 'Precio de tu cel';
    let contado = 'Precio de contado';
    let mostrarCuotas = true;
    if (tipoProducto === 'POSPAGO' && textoPospago?.terminal) {
      label = textoPospago.terminal.textoPrecio ?? label;
      contado = textoPospago.terminal.textoContado ?? contado;
      mostrarCuotas = textoPospago.terminal.mostrarCuotas ?? mostrarCuotas;
    }
    if (cuotas === 'SI' && textoCuota && aceptaCuotas && mostrarCuotas) {
      label = atributesMap['attr-titulo-cuotas'] || `${label} financiado`;
      const precioCuota = parseFloat(textoCuota);
      if (Number.isNaN(precioCuota)) {
        // eslint-disable-next-line react/no-danger
        labelCuota = <p className="price-cuota" dangerouslySetInnerHTML={{ __html: textoCuota }} />;
      } else {
        const cuota = currencyFormat(price.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price / precioCuota).split('.');
        labelCuota = cuotaFormat(cuota, textoCuota, formatoCuotas);
      }
      if (hasPromo) {
        labelContado = <p className="price-before">{contado}</p>;
      } else {
        paymentLabel = contado;
      }
      hasPromo = false;
      priceclass = 'product--box--price cuota';
    }
  }
  let phonePrice;
  if (curencyOffer && precio_minimo_incluido) {
    phonePrice = parseFloat(`${curencyOffer[0]}.${curencyOffer[1]}`);
    if (phonePrice <= precio_minimo_incluido) {
      isIncluded = true;
    } else {
      isIncluded = false;
    }
  }

  const onlyOffer = (
    <div className={priceclass}>
      <p>{label}</p>

      {isIncluded && tipoProducto === 'POSPAGO' ? ' ' : labelCuota }

      {isIncluded === true && tipoProducto === 'POSPAGO' ? <p className="price" style={{ fontSize: '1.5rem' }}><span>INCLUIDO</span></p> : ''}

      {labelCuota && tipoProducto === 'POSPAGO' && name ? <span>En un plan de <span className="product--plan-description">{name}</span></span> : ''}

      {labelContado }

      {isIncluded && tipoProducto === 'POSPAGO' ? '' : (
        <>
          <p className="price-before">{paymentLabel}</p>
          <p className="price">
            <span className="symbol">{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</span>
            {(curencyOffer ? curencyOffer[0] : [])}.
            <span className="symbol">{(curencyOffer ? curencyOffer[1] : [])}</span>
          </p>
        </>
      )}
      { !labelCuota && tipoProducto === 'POSPAGO' && name ? <span>En un plan de <span className="product--plan-description">{name}</span></span> : ''}
    </div>
  );

  const listVsOffer = (
    <div className="product--box--price">
      <p>{label}</p>
      {isIncluded === true && tipoProducto === 'POSPAGO' ? <p className="price" style={{ fontSize: '1.5rem' }}><span>INCLUIDO</span></p> : ''}
      <>
        <p className="price-before">{paymentLabel}</p>
        <p className="price is-promo">
          <span className="symbol">{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</span>
          {(curencyOffer ? curencyOffer[0] : [])}.
          <span className="symbol">{(curencyOffer ? curencyOffer[1] : [])}</span>
        </p>
      </>
      {tipoProducto === 'POSPAGO' && name ? <span>En un plan de <span className="product--plan-description">{name}</span></span> : ''}
      <del className="price del">
        <del className="symbol">{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</del>
        {(curencyList ? curencyList[0] : [])}.
        <del className="symbol">{(curencyList ? curencyList[1] : [])}</del>
      </del>
    </div>
  );

  return (
    <Fragment>
      {hasPromo ? listVsOffer : onlyOffer}
    </Fragment>
  );
};

const ProductBoxColors = ({ colors }) => {
  const itemInfo = helpers.colorProduct(colors);
  const colorList = map(itemInfo, (color, key) => {
    const index = `color--${key}`;
    const colorKey = FacetsUtils.getColorsFilter(key);
    const available = color.available;
    let output = '';
    if (available) {
      output = (
        <li key={index}>
          <p><span className={`color-${colorKey}`} /></p>
        </li>
      );
    } else {
      output = '';
      // output = (
      //   <li key={index} className="disabled">
      //     <span className={`color-${colorKey}`} />
      //   </li>
      // );
    }
    return output;
  });

  return (
    <Fragment>
      <div className="color">
        <p>{colorList.length} {colorList.length > 1 ? 'colores' : 'color'}</p>
        <ul>
          {colorList}
        </ul>
      </div>
    </Fragment>
  );
};

// const ProductBoxPospago = () => (
//   <Link to="/" className="product--box-pospago">
//     <b>¡Ahorra!</b>
//     <span>Este equipo en plan pospago desde</span>
//     <b>Q895.00</b>
//   </Link>
// );

function isESIM(items) {
  for (let i = 1; i < items.length; i += 1) {
    const item = items[i];
    if (item.attributes.find(a => a.identifier === 'attr-conf-esim')?.value === 'SI') {
      return true;
    }
  }
  return false;
}

const ProductBoxUI = ({
  props, onProductClick, name, selected, defaultPlanName, listCompare, setListCompare, categorySlug, setShowModalComparator,
  categorySlugSearch = '', showESimIndicator = false,
}) => {
// const ProductBoxUI = ({ props, onProductClick, name, selected, defaultPlanName }) => {
  const { orderStore } = useStores();
  const [precio_minimo_incluido, setPrecio_minimo_incluido] = useState('');
  const [product_button_message, setProduct_button_message] = useState('');
  const maxItemCompare = 5;
  const typeProductNoValidate = ['POSPAGO', 'PLAN', 'PLANFIJO'];
  const [esimIndicator, setEsimIndicator] = useState(null);

  // const [titleButton, setTitleButton] = useState('');
  useEffect(() => {
    let mounted = true;
    async function init() {
      await Promise.all([
        orderStore.getConfig(),
        orderStore.getConfigEsim(),
      ]);
      if (mounted) {
        if (orderStore.getEsimConfig.success) {
          setEsimIndicator(orderStore.getEsimConfig.data.data.esimIndicator);
        }
        if (orderStore.getCartConfig.success) {
          setPrecio_minimo_incluido(orderStore.getCartConfig.data.data.precio_minimo_incluido || 0);
          setProduct_button_message(orderStore.getCartConfig.data.data.product_button_message || '');
        }
      }
    }
    init();
    return () => {
      mounted = false;
    }
  }, []);

  const handleSetListCompare = (tipoProducto, item) => {
    const resultMinPrice = calculateTheMinPriceOffer(props.items);
    const resultColor = getProductsColors(props.items);
    const resultSize = getProductsSize(props.items);
    const resultSizeScreen = getProductsSizeScreen(props.items);

    const allPartNumbers = [];
    props.items.map(itemPart => allPartNumbers.push(itemPart.part_number));
    const marcaArray = item.attributes.filter(itemMarca => itemMarca.identifier === 'filt-marca');

    const tempItemCompare = {
      category: tipoProducto,
      linkPartNumber: props.part_number,
      checked: true,
      imageLocal: item.images,
      nameLocal: item.locales[process.env.NEXT_PUBLIC_LOCALE].name,
      linkName: item.locales[process.env.NEXT_PUBLIC_LOCALE].seo.name,
      priceLocal: { [process.env.NEXT_PUBLIC_CURRENCY]: resultMinPrice },
      sizes: resultSize,
      colors: resultColor,
      sizesScreen: resultSizeScreen,
      marca: marcaArray.length > 0 ? marcaArray : [{ name: '--', value: '--' }],
      allPartNumbers,
    };

    const itemCompare = { ...item, ...tempItemCompare };

    console.debug(itemCompare);
    const numberItemCompare = listCompare.filter(itemNumber => itemNumber.type === itemCompare.type).length + 1;
    const existItemCompare = listCompare.filter(itemExist => itemExist.part_number === itemCompare.part_number);
    if (numberItemCompare <= maxItemCompare || existItemCompare.length > 0) {
      if (existItemCompare.length === 0) {
        const listCompareSessionStorage = JSON.parse(sessionStorage.getItem(`${categorySlug}`));
        // setIsChecked(true)
        props.inputChecked = true;
        if (listCompareSessionStorage === null) {
          sessionStorage.setItem(`${categorySlug}`, JSON.stringify([itemCompare]));
          setListCompare([itemCompare]);
        } else {
          sessionStorage.setItem(`${categorySlug}`, JSON.stringify([...listCompareSessionStorage, itemCompare]));
          const newListCompare = JSON.parse(sessionStorage.getItem(`${categorySlug}`));
          setListCompare(newListCompare);
        }
      } else {
        // setIsChecked(false)
        props.inputChecked = false;
        // resetCatalog(categorySlug,categoryName,categoryId)
        const cleanOneItemCompare = listCompare.filter(itemClean => itemClean.part_number !== itemCompare.part_number);
        sessionStorage.setItem(`${categorySlug}`, JSON.stringify(cleanOneItemCompare));
        const newListCompare = JSON.parse(sessionStorage.getItem(`${categorySlug}`));
        setListCompare(newListCompare);
      }
    } else {
      setShowModalComparator(true);
    }
  };

  let title = '';
  helpers.ordenar(props);
  const item = props.items[0];
  if (item) {
    const attrMap = helpers.convertAttributes(item.attributes);
    const tipoProducto = attrMap['attr-conf-tipoproducto'];
    const tipoPlan = attrMap['attr-conf-tipoplan'] || '';
    const endpoint = tipoProducto === 'OTRO' ? '/productx/' : tipoProducto === 'POSPAGO' ? '/productp/' : '/product/';
    const link = `${endpoint + item.locales[process.env.NEXT_PUBLIC_LOCALE].seo.name}/${props.part_number}`;
    const productClick = (tipo) => {
      analytics.productClick(item, attrMap, tipoProducto, tipo);
    };
    // console.log(props);
    if (!tipoProducto) return null;
    showESimIndicator = attrMap['attr-conf-esim'] === 'SI' || isESIM(props.items);
    const tipoProd = tipoProducto === 'PREPAGO' || tipoProducto === 'OTRO' || tipoProducto === 'POSPAGO';
    const className = tipoProd ? 'product--box' : 'product--box--plan';

    let boxColors;
    let title2;

    if (tipoProducto) {
      // eslint-disable-next-line default-case
      switch (item.type) {
        case '1': //PREPAGO
          title = product_button_message[1];
          break;
        case '2': // PLAN POSPAGO
          // eslint-disable-next-line no-case-declarations
          const titles = product_button_message[2] ? product_button_message[2].split('|') : '';
          if (titles) {
            title = titles[0];
            title2 = titles[1];
          }
          break;
        case '4': //CLARO HOGAR
          title = product_button_message[4];
          break;
        case '5': //ACCESORIOS
          title = product_button_message[5];
          break;
        case '6': // TERMINAL POSPAGO
          title = product_button_message[6];
          break;
      }
    }

    if (tipoProd) {
      boxColors = <ProductBoxColors colors={props} />;
    } else if (tipoProducto === 'PLAN' && tipoPlan.toUpperCase() === 'FIJO') {
      const classn = `${className} pospago`;
      const onClick = (e) => {
        if (onProductClick) {
          const plansName = item.locales[process.env.NEXT_PUBLIC_LOCALE].name;
          onProductClick(item.part_number, attrMap['attr-conf-default-plazo'], plansName, e);
        }
      };
      return (
        <article className={classn} onClick={onClick} style={{ position: 'relative' }}>
          <span className="no-link-box">
            <ProductBoxTitle title={item} />
            {
              showESimIndicator && (
                <ESimIndicator label={esimIndicator?.label} image={esimIndicator?.image} />
              )
            }
            <ProductBoxImg image={item} />
            <ProductBoxPrice price={item} planName={name} defaultPlanName={defaultPlanName} />
            <Link
              className="link-box"
              to={link}
              onClick={(e)=> {
                e.stopPropagation();
                productClick();
                //blukai function, removida
              }}
            >
              <span>{selected === item.part_number ? title2 || 'Comprar' : title || 'Seleccionar'}</span>
            </Link>
          </span>
        </article>
      );
    }

    return (
      <article className={className} style={{ position: 'relative' }}>
        <Link
          to={link}
          onClick={()=> {
            productClick();
            //blukai function, removida
            }
          }
          className={tipoProducto !== 'POSPAGO' ? 'max95' : null}
        >
          <ProductBoxTitle title={item} />
          {
            showESimIndicator && (
              <ESimIndicator label={esimIndicator?.label} image={esimIndicator?.image} />
            )
          }
          <ProductBoxImg image={item} />
          <ProductBoxPrice price={item} planName={name} defaultPlanName={defaultPlanName} />
          {boxColors}
          <b>
            <span>{title || 'Comprar'}</span>
          </b>
        </Link>
        {
          ((!typeProductNoValidate.includes(tipoProducto)) && !categorySlugSearch.match(/\/search/)) && (
            <div className="temp-button-compare">

              <label className="radio">
                <input
                  checked={!!props.inputChecked}
                  onClick={()=>{productClick();
                    //blukai function, removida
                  }}

                  onChange={() => handleSetListCompare(tipoProducto, item)}
                  type="checkbox"
                  id="comparar"
                  value="comparar"
                />
                <span
                  className={`${props.inputChecked ? 'checked' : 'check'}`}
                />
                Comparar
              </label>
            </div>
          )
        }
      </article>
    );
  }
  return null;
};

ProductBoxTitle.propTypes = {
  title: PropTypes.shape({}),
};

ProductBoxUI.propTypes = {
  props: PropTypes.shape({
    available: PropTypes.bool,
    buyable: PropTypes.bool,
  }),
  part_number: PropTypes.string,
};

ProductBoxTitle.defaultProps = {
  title: {},
};

ProductBoxUI.defaultProps = {
  props: {},
  part_number: '',
  showESimIndicator: false,
  esimIndicator: null
};

ProductBoxPrice.propTypes = {
  price: PropTypes.shape({}),
};

ProductBoxPrice.defaultProps = {
  price: {},
};

ProductBoxImg.propTypes = {
  image: PropTypes.shape({}),
};

ProductBoxImg.defaultProps = {
  image: {},
};

ProductBoxColors.propTypes = {
  colors: PropTypes.shape({}),
};

ProductBoxColors.defaultProps = {
  colors: {},
};

export default ProductBoxUI;
